import { tr } from "../lib/i18n";

const cell = "h-9 w-20 rounded-lg border border-[hsl(var(--border))] bg-white px-2 text-sm";

// Rows of {from_cars, to_cars (blank = and more), percent}. The next row always starts after the previous one.
export const SlabEditor = ({ slabs, onChange, testid = "slabs" }) => {
  const set = (i, k, v) => {
    const next = slabs.map((s, j) => (j === i ? { ...s, [k]: v } : s));
    for (let j = 1; j < next.length; j++) next[j] = { ...next[j], from_cars: (Number(next[j - 1].to_cars) || 0) + 1 };
    onChange(next);
  };
  const add = () => {
    const last = slabs[slabs.length - 1];
    const from = last ? (Number(last.to_cars) || Number(last.from_cars) + 9) + 1 : 1;
    const fixed = last && !last.to_cars ? slabs.map((s, j) => (j === slabs.length - 1 ? { ...s, to_cars: from - 1 } : s)) : slabs;
    onChange([...fixed, { from_cars: from, to_cars: "", percent: "" }]);
  };
  return (
    <div className="grid gap-2" data-testid={testid}>
      {slabs.map((s, i) => (
        <div key={i} className="flex flex-wrap items-center gap-2 text-sm" data-testid={`${testid}-row-${i}`}>
          <span dir="ltr" className="w-10 text-end">{s.from_cars}</span><span>–</span>
          <input className={cell} dir="ltr" inputMode="numeric" placeholder="+" value={s.to_cars ?? ""} onChange={(e) => set(i, "to_cars", e.target.value.replace(/\D/g, ""))} data-testid={`${testid}-to-${i}`} />
          <span>{tr("com.cars")}</span>
          <input className={cell} dir="ltr" inputMode="decimal" value={s.percent} onChange={(e) => set(i, "percent", e.target.value)} data-testid={`${testid}-pct-${i}`} /><span>%</span>
          <button type="button" className="text-xs text-red-600" onClick={() => onChange(slabs.filter((_, j) => j !== i))} data-testid={`${testid}-del-${i}`}>{tr("x.remove")}</button>
        </div>
      ))}
      <button type="button" className="btn-ghost justify-self-start text-sm" onClick={add} data-testid={`${testid}-add`}>+ {tr("com.add_slab")}</button>
      <p className="text-xs text-[var(--gray-400)]">{tr("com.slab_help")}</p>
    </div>
  );
};

export const toApiSlabs = (slabs) => slabs.map((s) => ({ from_cars: Number(s.from_cars), to_cars: s.to_cars === "" || s.to_cars == null ? null : Number(s.to_cars), percent: Number(s.percent) }));
